import {
  clearWorkOSPendingAuthorization,
  markWorkOSAuthorizationStarted,
} from "@/lib/workos-callback";

/**
 * AuthKit removes local session data when its refresh token is rejected.
 * Start the normal hosted sign-in flow so the user is not left with a stale
 * UI that can no longer make authenticated API requests.
 */
export function startWorkOSReauthentication(signIn: () => Promise<void>): void {
  markWorkOSAuthorizationStarted();
  void signIn().catch((error) => {
    clearWorkOSPendingAuthorization();
    console.error("[auth] Unable to start WorkOS re-authentication", error);
  });
}
